import { render } from "./TopBarMessages.vue?vue&type=template&id=11982f59&scoped=true&ts=true"
import script from "./TopBarMessages.vue?vue&type=script&lang=ts"
export * from "./TopBarMessages.vue?vue&type=script&lang=ts"

import "./TopBarMessages.vue?vue&type=style&index=0&id=11982f59&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11982f59"]])

export default __exports__